import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Main from './components/Main';
import Content from './components/Content';
import Footer from './components/Footer';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faPhone, faBuilding } from '@fortawesome/free-solid-svg-icons';

library.add(faEnvelope, faPhone, faBuilding);

ReactDOM.render(<Main />, document.getElementById('root'));
ReactDOM.render(<Content />, document.getElementById('content'));
ReactDOM.render(<Footer />, document.getElementById('footer'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js